import { ReactNode } from "react";

import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type TooltipModalTitleProps = {
  children: ReactNode;
};

export const TooltipModalTitle = ({ children }: TooltipModalTitleProps) => {
  return (
    <Typography variant="p-t6" tag="h2" id="tooltip-modal-title" className={styles.title}>
      {children}
    </Typography>
  );
};

TooltipModalTitle.displayName = "DS.TooltipModal.Title";
